import EzModalController from 'layouts/modal/modal-controller';

export default class SignupSurveyModalController extends EzModalController {
  static targets = [
    'surveyForm',
  ];

  connect() {
    super.connect();

    this.flagLoaded();
  }

  disconnect() {
    super.disconnect();
  }

  close = (event) => {
    super.close(event, () => {}, this.dismissAfterUserClose);
  }

  dismissAfterUserClose = (event) => {
    // we only want to fire the dismiss action if the user manually closes the modal
    if (event.currentTarget.getAttribute('data-action').includes('signup-survey-modal#close')) {
      const userId = this.surveyFormTarget.getAttribute('data-user-id');

      Turbolinks.visit(`/signup/survey/dismiss/${userId}`);
    }
  }
}
